<template>
  <div class="StoreDeviceRelation">
    <div class="select">
      <el-form ref="form" :model="request" label-position="right">
        <el-form-item><el-input v-model="request.name" placeholder="门店名称" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item><el-input v-model="request.contactName" placeholder="联系人" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item><el-input v-model="request.contactPhone" placeholder="联系电话" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getAllStore()">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="storeList">
      <el-table :data="response.data"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" 
                style="margin:auto;width:calc(100% - 30px)" height="667" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
        <el-table-column label="门店编号" align="center" prop="code"></el-table-column>
        <el-table-column label="门店名称" align="center" prop="name"></el-table-column>
        <el-table-column label="门店性质" align="center">
           <template slot-scope="scope">
            <el-tag type="success">{{scope.row.type}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否签约" align="center">
          <template slot-scope="scope">
            <el-tag type="success">{{scope.row.sign}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否部署" align="center">
          <template slot-scope="scope">
            <el-tag type="success">{{scope.row.deploy}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="设备数量" align="center" prop="devices"></el-table-column>
        <el-table-column label="操作" align="center">
         <template slot-scope="scope">
            <el-button type="danger" plain @click="storeDetail(scope.row.id)" size="small">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
    </div>
    <store-detail v-if="storeDetailDialog" ref="storeDetail" @unbinding-succeed="unbindingSucceed"></store-detail>
  </div>
</template>

<script>
import { getStoreList } from "../../api/relation/storeDeviceRelation";
import StoreDetail from './storeDetail.vue'
import { formatDate } from "../../utils/date";
export default {
  components: { StoreDetail },
  name: "StoreDeviceRelation",
  data() {
    return {
      request: {
        name: '',
        contactName: '',
        contactPhone: '',
        current: '',
        size: ''
      },
      response: {data: [], total: 0},
      query: {current: 1, size: 15},
      loading: false,
      storeDetailDialog: false,
    };
  },
  methods: {
    /**
     * 获取门店列表
     */
    getAllStore() {
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      getStoreList(this.request).then((result) => {
        this.response.data = result.data.records;
        this.response.total = result.data.total;
      });
    },

    /**
     * 页码改变触发事件
     */
    currenChangeHandle(value) {
      this.query.current = value;
      this.getAllStore()
    },

    /**
     * 门店详情
     */
    storeDetail(id){
      this.storeDetailDialog = true;
      this.$nextTick(() =>{
        this.$refs.storeDetail.init(id);
      })
    },

    /**
     * 重置
     */
    reset(){
      this.request.name = "";
      this.request.contactName = "";
      this.request.contactPhone = "";
      this.query.current = 1;
      this.query.size = 15;
      this.getAllStore();
    },

    /**
     * 解绑成功重新请求
     */
    unbindingSucceed(){
      this.getAllStore()
    }
  },
  created() {
    this.getAllStore();
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>

<style scoped>
.StoreDeviceRelation {
  width: 100%;
  height: 100%;
}
.businessStoreRelation {
  width: 100%;
  height: 100%;
}
.el-form {
  float: left;
}

.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/relation/storedevicerelation.vue